import { render, staticRenderFns } from "./chooseDeduct.vue?vue&type=template&id=2b2e5ce5&scoped=true&"
import script from "./chooseDeduct.vue?vue&type=script&lang=js&"
export * from "./chooseDeduct.vue?vue&type=script&lang=js&"
import style0 from "./chooseDeduct.vue?vue&type=style&index=0&id=2b2e5ce5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2e5ce5",
  null
  
)

export default component.exports